<template>
    <div
        :class="[
            'montserrat-regular-font',
            isCapacitorEmbed ? 'background-transparent' : 'background-neutral',
        ]"
        ref="expressPdpDivOne"
        v-resize="onResize"
    >
        <!-- <template v-if="true"> -->
        <template v-if="!templateList?.length">
            <v-container class="mt-0 mb-n3 pt-8 pdp-skeletons">
                <v-skeleton-loader
                    class="mb-3 bg-transparent"
                    width="100%"
                    type="table-heading"
                ></v-skeleton-loader>
                <v-skeleton-loader
                    class="mt-n2 mb-3 bg-transparent"
                    width="100%"
                    type="heading"
                ></v-skeleton-loader>
                <v-skeleton-loader
                    class="bg-transparent mb-n14"
                    width="100%"
                    type="image"
                ></v-skeleton-loader>
                <div class="bg-white mx-n4 pt-16 px-4">
                    <v-skeleton-loader
                        class="preview-slider-button-skeleton bg-transparent"
                        width="100%"
                        type="text"
                    ></v-skeleton-loader>
                    <v-row no-gutters class="bg-transparent">
                        <v-col cols="3" class="">
                            <v-skeleton-loader
                                class="mb-n1 mt-n2 bg-transparent"
                                width="100%"
                                type="heading"
                            ></v-skeleton-loader>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mt-2">
                        <v-col cols="3" v-for="n in 4" class="px-2">
                            <v-skeleton-loader
                                class="express-pdp-loader bg-transparent rounded"
                                width="100%"
                                type="image"
                            ></v-skeleton-loader>
                        </v-col>
                    </v-row>
                    <v-skeleton-loader
                        class="bg-transparent"
                        width="100%"
                        type="text"
                    ></v-skeleton-loader>
                    <v-row class="my-1 px-2 pt-4 pb-2 align-center qty-section-skeletons">
                        <!-- labels -->
                        <v-col cols="4" class="py-0">
                            <v-skeleton-loader
                                class="bg-transparent"
                                width="100%"
                                type="text"
                            ></v-skeleton-loader>
                        </v-col>
                        <v-col offset="4" cols="4" class="text-right py-0">
                            <v-skeleton-loader
                                class="bg-transparent"
                                width="100%"
                                type="text"
                            ></v-skeleton-loader>
                        </v-col>
                        <!-- inputs -->
                        <v-col cols="6" class="py-0">
                            <v-skeleton-loader
                                class="bg-transparent"
                                width="100%"
                                type="heading"
                            ></v-skeleton-loader>
                        </v-col>
                        <v-col offset="2" cols="4" class="text-right py-0">
                            <v-skeleton-loader
                                class="bg-transparent"
                                width="100%"
                                type="heading"
                            ></v-skeleton-loader>
                        </v-col>
                    </v-row>
                    <v-skeleton-loader
                        class="personalized-btn-skeleton bg-transparent"
                        width="100%"
                        type="heading"
                    ></v-skeleton-loader>
                    <v-skeleton-loader
                        class="bg-transparent"
                        width="100%"
                        type="text@8"
                    ></v-skeleton-loader>
                    <v-skeleton-loader
                        class="my-n1 bg-transparent"
                        width="50%"
                        type="heading"
                    ></v-skeleton-loader>
                    <v-skeleton-loader
                        class="my-n1 bg-transparent"
                        width="50%"
                        type="heading"
                    ></v-skeleton-loader>
                </div>
            </v-container>
        </template>
        <template v-else>
            <v-row
                :class="[
                    'mx-0 pt-12',
                    isCapacitorEmbed ? 'background-transparent' : 'background-neutral',
                ]"
            >
                <!-- product name -->
                <v-col cols="12" class="d-block py-2 px-6 ma-0 mb-3">
                    <h1
                        class="text-capitalize playfair-display-regular-font font-weight-700 fontsize-36 ma-0 pa-0 ls-n01 text-white"
                    >
                        {{ productDetails.name }}
                    </h1>
                    <span class="fontsize-20 text-white">
                        Personalized
                        {{ getProductPartNames(this.productPartNames, false) }}</span
                    >
                </v-col>
                <!-- Template preview slider -->

                <v-col
                    cols="12"
                    :class="[
                        'pa-0 position-relative',
                        isCapacitorEmbed ? 'carousel-div-embed' : 'carousel-div',
                    ]"
                >
                    <vueper-slides
                        class="no-shadow mx-0 express-pdp-carousel"
                        :visible-slides="perSlides"
                        ref="mainSlider"
                        :dragging-distance="1"
                        :fixed-height="slideHeight"
                        :touchable="true"
                        :bullets="false"
                        @slide="onSlideChange"
                    >
                        <template #arrow-left>
                            <v-btn
                                class=""
                                color="transparent"
                                height="36"
                                width="36"
                                :ripple="false"
                                elevation="0"
                                variant="flat"
                                icon
                            >
                                <v-img
                                    :src="sliderLeftWhiteIcon"
                                    alt="left-white-icon"
                                    width="24"
                                    height="24"
                                    class="arrow-border"
                                ></v-img>
                            </v-btn>
                        </template>
                        <template #arrow-right>
                            <v-btn
                                class=""
                                color="transparent"
                                height="36"
                                width="36"
                                :ripple="false"
                                elevation="0"
                                variant="flat"
                                icon
                            >
                                <v-img
                                    :src="sliderRightWhiteIcon"
                                    alt="right-white-icon"
                                    width="24"
                                    height="24"
                                    class="arrow-border"
                                ></v-img>
                            </v-btn>
                        </template>
                        <vueper-slide
                            v-for="(img, index) in productImageSliderImages"
                            :key="`${index}_slider_img`"
                        >
                            <template v-slot:content>
                                <div
                                    class="vueperslide__content-wrapper vueperslide__title"
                                    :class="
                                        index || typeof productImageSliderImages[0] !== 'object'
                                            ? ''
                                            : 'pt-5 pb-5 px-11'
                                    "
                                >
                                    <div
                                        v-if="img && typeof img === 'object' && img.length > 0"
                                        class="position-relative d-flex justify-start align-start"
                                        :style="{
                                            width: sliderPreviewLayout.innerWidth,
                                            // height: '100%',
                                        }"
                                        ref="innerContainerParent"
                                    >
                                        <!-- envelope image -->
                                        <div
                                            v-if="img[1]"
                                            class="position-absolute"
                                            :class="partNameContent === 'sideFold' ? 'mr-n8' : ''"
                                            :style="{
                                                right: '0px',
                                                width: sliderPreviewLayout.frontImageContainerWidth,
                                            }"
                                        >
                                            <img
                                                :src="img[1]"
                                                alt=""
                                                :style="{
                                                    width: sliderPreviewLayout.backImageWidth,
                                                }"
                                                class="back-image-shadow"
                                                @error="onImageError($event)"
                                            />
                                        </div>
                                        <!-- card image -->
                                        <div
                                            class=""
                                            :class="partNameContent === 'sideFold' ? 'ml-n8' : ''"
                                            :style="{
                                                width: sliderPreviewLayout.frontImageContainerWidth,
                                                marginTop:
                                                    productTotalPartsCount === 1
                                                        ? ''
                                                        : `${cardTopMargin}%`,
                                            }"
                                        >
                                            <img
                                                ref="imgRef"
                                                :src="img[0]"
                                                alt=""
                                                class="front-image-shadow"
                                                :style="`width: ${sliderPreviewLayout.frontImageWidth}`"
                                                @load="onImageLoad"
                                                @error="onImageError($event)"
                                            />
                                        </div>
                                    </div>
                                    <img
                                        v-else-if="img"
                                        :src="img"
                                        ref="defaultImgRef"
                                        style="width: 100%; height: 100%; object-fit: cover"
                                        :alt="productDetails.name"
                                        :title="productDetails.name"
                                        loading="lazy"
                                        @load="onProductDefaultImageLoad($event)"
                                        @error="onImageError($event)"
                                    />
                                    <img
                                        v-else
                                        :src="defaultPlaceholderImage"
                                        :style="{
                                            zIndex: 1,
                                            width: '90%',
                                        }"
                                        class="h-100"
                                        alt=""
                                        @load="onImageErrorDefault()"
                                    />
                                </div>
                            </template>
                        </vueper-slide>
                    </vueper-slides>
                </v-col>
                <v-row no-gutters class="px-6 py-4 bg-white slider-bullet-div">
                    <v-col
                        v-for="(item, index) in productImageSliderImages"
                        :key="`${index}_slider_bullet`"
                        class=""
                    >
                        <div
                            class="w-100 cursor-pointer"
                            @click.native="goToPreviewSlide(index)"
                            :class="[
                                activePreviewIndex === index
                                    ? 'bullets-active-background'
                                    : 'bullets-background',
                            ]"
                            :style="{ height: '2px' }"
                        ></div>
                    </v-col>
                </v-row>
                <!-- end Template preview slider -->
            </v-row>
            <v-container class="bg-white">
                <v-row class="mx-1">
                    <template v-if="templateList?.length > 1">
                        <v-col cols="12" class="pa-0 mt-1 color-ui-text">
                            <span class="font-weight-600 fontsize-18"> Choose Variation </span>
                        </v-col>
                        <!-- preview thumbnails -->
                        <v-col cols="12" class="px-0 py-3 color-ui-text">
                            <div class="d-flex align-center w-100">
                                <!-- LEFT ARROW -->
                                <v-btn
                                    class="slider-arrow-side"
                                    variant="text"
                                    color="transparent"
                                    height="16"
                                    width="16"
                                    elevation="0"
                                    icon
                                    @click="selectPrev"
                                    :disabled="isAtLeftEnd"
                                >
                                    <!-- :disabled="activeIndex === 0" -->
                                    <v-img
                                        :src="sliderLeftIcon"
                                        alt="left"
                                        width="12"
                                        height="12"
                                    />
                                </v-btn>

                                <!-- SCROLLABLE LIST -->
                                <div
                                    ref="scrollContainer"
                                    class="variation-scrollable-divs flex-grow-1 d-flex flex-row align-center"
                                    @scroll="checkVariantDivScrollEdges"
                                    style="
                                        overflow-x: auto;
                                        scroll-behavior: smooth;
                                        scrollbar-width: none;
                                    "
                                >
                                    <div
                                        v-for="(currentItem, index) in templateList"
                                        :key="`${index}_variantion_div`"
                                        :id="`${index}_variantion_div`"
                                        class="slider-thumbnail cursor-pointer d-flex justify-center align-center"
                                        :style="{
                                            // height: computedThumbnailHeight,
                                        }"
                                        @click="setActivePreview(index)"
                                        :class="[
                                            index > 0 ? 'mx-2' : 'mr-2',
                                            index === templateList.length - 1 ? 'mx-2' : '',
                                            {
                                                'active-slider-thumbnail': activeIndex === index,
                                            },
                                        ]"
                                    >
                                        <div
                                            v-if="currentItem && currentItem.id"
                                            class="position-relative"
                                            :style="{
                                                width: thumbSliderPreviewLayout.innerWidth,
                                                // height: '100%',
                                            }"
                                        >
                                            <!-- skeleton while loading images in slider  -->
                                            <v-skeleton-loader
                                                v-if="
                                                    productAllVariantsAllImages[
                                                        currentItem.id
                                                    ]?.[0] && !isThumbnailLoadedSuccessfully
                                                "
                                                width="100%"
                                                type="image"
                                                class="thumbnail-image-skeleton"
                                            ></v-skeleton-loader>
                                            <!-- default crane img for product which dont have images created -->
                                            <img
                                                v-if="
                                                    !productAllVariantsAllImages[currentItem.id]
                                                        ?.length
                                                "
                                                :src="defaultPlaceholderImage"
                                                :style="{
                                                    paddingTop: '10%',
                                                    zIndex: 1,
                                                    width: '90%',
                                                }"
                                                class="h-100"
                                                alt=""
                                                @load="onImageErrorDefault(currentItem.id)"
                                            />
                                            <!-- product envelope image -->
                                            <img
                                                v-if="
                                                    productAllVariantsAllImages[currentItem.id]?.[1]
                                                "
                                                :class="
                                                    isThumbnailLoadedSuccessfully
                                                        ? 'position-absolute'
                                                        : 'position-absolute d-none'
                                                "
                                                :src="
                                                    productAllVariantsAllImages[currentItem.id][1]
                                                "
                                                alt=""
                                                :style="{
                                                    right: '0px',
                                                    width: thumbSliderPreviewLayout.backImageWidth,
                                                }"
                                                @error="onImageError($event, currentItem.id)"
                                            />

                                            <!-- product Card image -->
                                            <div
                                                class=""
                                                :style="{
                                                    width: thumbSliderPreviewLayout.frontImageWidth,
                                                    zIndex: 1,
                                                    marginTop:
                                                        productTotalPartsCount === 1 ? '' : '10%',
                                                    height: computedThumbnailHeight + 'px',
                                                }"
                                                :class="
                                                    isThumbnailLoadedSuccessfully
                                                        ? 'position-relative'
                                                        : 'position-absolute d-none'
                                                "
                                            >
                                                <img
                                                    ref="thumbImgRef"
                                                    v-if="
                                                        productAllVariantsAllImages[
                                                            currentItem.id
                                                        ]?.[0]
                                                    "
                                                    :src="
                                                        productAllVariantsAllImages[
                                                            currentItem.id
                                                        ][0]
                                                    "
                                                    alt=""
                                                    :style="{
                                                        width: isThumbnailImageLoaded(
                                                            currentItem.id
                                                        )
                                                            ? `${thumbSliderPreviewLayout.frontImageWidth} `
                                                            : '100%',
                                                    }"
                                                    @load="
                                                        detectThumbnailHeight(
                                                            $event,
                                                            currentItem.id
                                                        )
                                                    "
                                                    @error="
                                                        errorLoadingThumbnailImage(currentItem.id)
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- RIGHT ARROW -->
                                <v-btn
                                    class="slider-arrow-side"
                                    variant="text"
                                    color="transparent"
                                    height="16"
                                    width="16"
                                    elevation="0"
                                    icon
                                    @click="selectNext"
                                    :disabled="isAtRightEnd"
                                >
                                    <!-- :disabled="activeIndex === templateList.length - 1" -->
                                    <v-img
                                        :src="sliderRightIcon"
                                        alt="right"
                                        width="12"
                                        height="12"
                                    />
                                </v-btn>
                            </div>
                        </v-col>
                        <!-- end preview thumbnails -->
                    </template>
                </v-row>
                <!-- paper and product lowest price (hidden when handwriting=true) -->
                <v-row v-if="!isHandwritingMode" class="mx-2 py-3" no-gutters>
                    <v-col cols="12" class="">
                        <span class="font-weight-500 color-ui-text text-base">
                            {{ getCurrentPaperInformation }}
                        </span>
                    </v-col>
                </v-row>

                <!-- Quantity (hidden when handwriting=true) -->
                <v-row v-if="!isHandwritingMode" class="px-2 pt-6 pb-2 align-center" no-gutters>
                    <v-col cols="8" class="">
                        <span class="font-weight-600 color-ui-text-highlighted fontsize-18">
                            Quantity
                        </span>
                    </v-col>
                    <v-col cols="4" class="text-right">
                        <span class="font-weight-600 color-ui-text-highlighted text-base">
                            Starting from
                        </span>
                    </v-col>
                </v-row>
                <v-row v-if="!isHandwritingMode" class="px-2 align-center pb-3" no-gutters>
                    <v-col cols="8" class="">
                        <div
                            v-if="
                                getCustomAttributeValue(
                                    productDetails.customAttribute,
                                    'personalized'
                                ) === 'Yes' &&
                                productDetails.status == '1' &&
                                qtyPriceOptions?.length > 0
                            "
                        >
                            <v-select
                                :items="qtyPriceOptions"
                                class="word-break line-height-21 ls-n009 font-weight-400 express-pdp-select-input text-primary"
                                item-title="price"
                                item-value="qty"
                                single-line
                                hide-details
                                v-model="selectedQty"
                                ref="selectedQty1"
                                bg-color="transparent"
                                :menu-icon="null"
                                density="compact"
                                variant="outlined"
                                base-color="primary"
                                @update:modelValue="productReward(selectedQty)"
                            >
                                <template v-slot:append-inner>
                                    <v-btn
                                        variant="text"
                                        height="12"
                                        width="12"
                                        elevation="0"
                                        :ripple="false"
                                        icon
                                    >
                                        <v-img
                                            :src="triangularUpArrowIcon"
                                            alt="left"
                                            width="16"
                                            height="16"
                                        />
                                    </v-btn>

                                    <v-btn
                                        variant="text"
                                        height="12"
                                        width="12"
                                        elevation="0"
                                        :ripple="false"
                                        icon
                                    >
                                        <v-img
                                            :src="triangularDownArrowIcon"
                                            alt="left"
                                            width="16"
                                            height="16"
                                        />
                                    </v-btn>
                                </template>
                                <template v-slot:selection="{ item }">
                                    <span
                                        class="fontsize-16 w-100 montserrat-regular-font color-ui-text-highlighted"
                                    >
                                        <v-row no-gutters class="align-center">
                                            <v-col cols="12">
                                                <span class="">{{ item.value }}</span>
                                                <span class="pl-1">
                                                    {{ productPartNameLabel }}
                                                </span>
                                            </v-col>
                                        </v-row>
                                    </span>
                                </template>

                                <template v-slot:item="{ props, item }">
                                    <v-list-item-title
                                        v-bind="props"
                                        class="fontsize-18 color-ui-text-highlighted line-height-21 ls-n009 font-weight-400 pl-4 mb-2 inputHoverEffect"
                                    >
                                        <v-row no-gutters class="">
                                            <v-col cols="2" class="text-center">
                                                <span class="mr-1 montserrat-regular-font">{{
                                                    item.value
                                                }}</span>
                                            </v-col>
                                            <v-col cols="10">
                                                <span class="ml-1 montserrat-regular-font">
                                                    {{ productPartNameLabel }}
                                                </span>
                                            </v-col>
                                        </v-row>
                                    </v-list-item-title>
                                </template>
                            </v-select>
                        </div>
                    </v-col>
                    <v-col cols="4" class="text-right">
                        <span class="font-weight-600 color-ui-text-highlighted fontsize-24">
                            ${{
                                getRoundedUpFinalPrice({
                                    qty: selectedQty,
                                    price: selectedQuantityPrice,
                                })
                            }}
                        </span>
                    </v-col>
                </v-row>
                <!-- personalize button -->
                <v-row class="mx-0 py-5" no-gutters>
                    <v-col
                        v-if="
                            getCustomAttributeValue(
                                productDetails.customAttribute,
                                'personalized'
                            ) === 'Yes' &&
                            productDetails.status == '1' &&
                            qtyPriceOptions?.length > 0 &&
                            stockFlag
                        "
                    >
                        <v-btn
                            block
                            size="x-large"
                            class="text-capitalize text-white ls-0 pb-1 border-radius-8"
                            color="#106C41"
                            @click="goToPersonalize(productDetails)"
                        >
                            <v-img :src="brushIcon" alt="brush" width="24" height="24"></v-img>
                            <span class="pl-1 fontsize-18">Personalize Your Stationery</span>
                        </v-btn>
                    </v-col>
                    <v-col class="pt-4" v-if="productDetails.status == '2' || !stockFlag">
                        <v-btn
                            block
                            size="x-large"
                            class="text-capitalize text-white ls-0 pb-1 border-radius-8"
                            rounded="0"
                            tile
                            color="#97ABB4"
                            depressed
                            >UNAVAILABLE</v-btn
                        >
                    </v-col>
                </v-row>
                <!-- gray box for personalized product that have envelope part -->
                <GrayBoxForPersonalizedProduct class="py-5 pt-3" v-if="productHasEnvelope" />

                <!-- description , materials, overview -->
                <v-row class="mx-0 pb-2 pt-3" no-gutters>
                    <v-col cols="12">
                        <p
                            class="line-height-21 fontsize-14 ls-n01 color-ui-text"
                            v-html="productDetails?.description"
                        ></p>
                    </v-col>
                    <v-col>
                        <v-expansion-panels multiple>
                            <v-expansion-panel
                                elevation="0"
                                class="pa-0 ma-0 express-pdp-expansion"
                                :height="48"
                                :min-height="48"
                            >
                                <v-expansion-panel-title
                                    class="background-transparent font-weight-600 fontsize-20 color-ui-text pa-0 ma-0"
                                    :height="48"
                                    :min-height="48"
                                    >Product Overview</v-expansion-panel-title
                                >
                                <v-expansion-panel-text class="pa-0">
                                    <ul class="fontsize-16 ls-n008 color-ui-text">
                                        <li
                                            v-if="
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'brand'
                                                )
                                            "
                                        >
                                            {{
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'brand'
                                                )
                                            }}
                                        </li>
                                        <li
                                            v-if="
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'product_def_type'
                                                )
                                            "
                                        >
                                            {{
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'product_def_type'
                                                )
                                            }}
                                        </li>
                                        <li
                                            v-if="
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'unit_description'
                                                )
                                            "
                                        >
                                            {{
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'unit_description'
                                                )
                                            }}
                                        </li>
                                        <li
                                            v-if="
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'product_dimensions'
                                                )
                                            "
                                        >
                                            {{
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'product_dimensions'
                                                )
                                            }}
                                        </li>
                                        <li
                                            v-if="
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'printing_process'
                                                )
                                            "
                                        >
                                            Printing Process -
                                            {{
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'printing_process'
                                                )
                                            }}
                                        </li>
                                        <li
                                            v-if="
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'processing_time'
                                                )
                                            "
                                        >
                                            {{
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'processing_time'
                                                )
                                            }}
                                        </li>
                                        <li
                                            v-if="
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'additional_feature_1'
                                                )
                                            "
                                        >
                                            {{
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'additional_feature_1'
                                                )
                                            }}
                                        </li>
                                        <li
                                            v-if="
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'additional_feature_2'
                                                )
                                            "
                                        >
                                            {{
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'additional_feature_2'
                                                )
                                            }}
                                        </li>
                                        <li
                                            v-if="
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'additional_feature_3'
                                                )
                                            "
                                        >
                                            {{
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'additional_feature_3'
                                                )
                                            }}
                                        </li>
                                        <li
                                            v-if="
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'additional_feature_4'
                                                )
                                            "
                                        >
                                            {{
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'additional_feature_4'
                                                )
                                            }}
                                        </li>
                                        <li
                                            v-if="
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'additional_feature_5'
                                                )
                                            "
                                        >
                                            {{
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'additional_feature_5'
                                                )
                                            }}
                                        </li>
                                        <li
                                            v-if="
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'additional_feature_6'
                                                )
                                            "
                                        >
                                            {{
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'additional_feature_6'
                                                )
                                            }}
                                        </li>
                                    </ul>
                                </v-expansion-panel-text>
                            </v-expansion-panel>
                            <v-expansion-panel
                                elevation="0"
                                class="pa-0 ma-0 express-pdp-expansion"
                                :height="48"
                                :min-height="48"
                            >
                                <v-expansion-panel-title
                                    class="background-transparent font-weight-600 fontsize-20 color-ui-text pa-0 ma-0"
                                    :height="48"
                                    :min-height="48"
                                    >Materials</v-expansion-panel-title
                                >
                                <v-expansion-panel-text class="pa-0">
                                    <ul class="fontsize-16 ls-n008 color-ui-text">
                                        <li
                                            v-if="
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'cotton_paper'
                                                )
                                            "
                                        >
                                            {{
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'cotton_paper'
                                                )
                                            }}
                                        </li>
                                        <li
                                            v-if="
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'paper_weight'
                                                )
                                            "
                                        >
                                            {{
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'paper_weight'
                                                )
                                            }}
                                        </li>
                                        <li
                                            v-if="
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'made_usa'
                                                )
                                            "
                                        >
                                            {{
                                                getCustomAttributeLable(
                                                    productDetails.customAttribute,
                                                    'made_usa'
                                                )
                                            }}
                                        </li>
                                    </ul>
                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                </v-row>
            </v-container>
        </template>
        <SnackbarComponent :snackbar="snackbar"></SnackbarComponent>
        <!-- <component
            type="application/ld+json"
            :is="'script'"
            v-html="productLdJson"
        >
        </component> -->
    </div>
</template>
<script>
import {
    mdiWindowClose,
    mdiPlus,
    mdiHeartOutline,
    mdiHeart,
    mdiAccountCircleOutline,
} from '@mdi/js'
const designerPageUrl = import.meta.env.VITE_DESIGNER_APP_URL
const retailorId = import.meta.env.VITE_RETAILOR_ID
import * as easings from 'vuetify/lib/services/goto/easing-patterns'
import SnackbarComponent from '@/components/common/SnackbarComponent.vue'
import GrayBoxForPersonalizedProduct from '@/components/common/GrayBoxForPersonalizedProduct.vue'
import { createHelpers } from 'vuex-map-fields'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

const mediaImageUrl = import.meta.env.VITE_APP_MEDIA_IMAGES_API_URL
const baseUrl = import.meta.env.VITE_BASE_URL
const cloudflareImageDeliveryUrl = import.meta.env.VITE_APP_CLOUDFLARE_IMAGES_DELIVERY_URL

const { mapFields: mapFieldsAuth } = createHelpers({
    getterType: 'auth/getField',
    mutationType: 'auth/updateField',
})
const { mapFields: registerInfo } = createHelpers({
    getterType: 'registration/getField',
    mutationType: 'registration/updateField',
})

import {
    getRoundedUpFinalPrice,
    getLable,
    customAttributeValue,
    googleAanalytics,
    googleAanalyticsEvent,
    setCategoryNameInLocal,
    commonValidationRules,
    useCloudflareImgUrl,
} from '@/services/util.service'
import productDefaultImage from '@/assets/defaultProduct.jpg'

import brushIcon from '@/assets/brush_icon.svg'
import sliderRightIcon from '@/assets/slider_right_arrow.svg'
import sliderLeftIcon from '@/assets/slider_left_arrow.svg'
import sliderLeftWhiteIcon from '@/assets/slider_left_arrow_white.svg'
import sliderRightWhiteIcon from '@/assets/slider_right_arrow_white.svg'

import triangularUpArrowIcon from '@/assets/triangular-up-arrow.svg'
import triangularDownArrowIcon from '@/assets/triangular-down-arrow.svg'

import { HANDWRITING_FLAG } from '@/plugins/handwritingMode'
import { getIsCapacitorEmbed } from '@/plugins/capacitorIframeBack'
export default {
    name: 'ExpressPDPComponent',
    props: ['stockFlag', 'categoryId'],
    components: {
        SnackbarComponent,
        VueperSlides,
        VueperSlide,
        GrayBoxForPersonalizedProduct,
    },
    data: () => ({
        mdiWindowClose,
        mdiPlus,
        mdiHeartOutline,
        mdiHeart,
        mediaImageUrl,
        mdiAccountCircleOutline,
        sliderLeftWhiteIcon,
        sliderRightWhiteIcon,
        brushIcon,
        sliderRightIcon,
        sliderLeftIcon,
        triangularUpArrowIcon,
        triangularDownArrowIcon,
        useCloudflareImgUrl,
        variants: [1366, 768, 360],
        attrs: {
            boilerplate: false,
            elevation: 0,
        },
        productDefaultImage: productDefaultImage,
        updateProgress: '',

        dropDownIcon: 'mdiPlus',
        iconColor: 'text-black',
        isActive: true,
        easings: Object.keys(easings),
        snackbar: {
            show: false,
            message: null,
            color: null,
            timeout: 0,
        },
        fillHeart: 'mdiHeart',
        outlineHeart: 'mdiHeartOutline',
        myBtnColor: null,
        isOutlineHeart: true,
        isFillHeart: false,
        tab: null,
        selectedQty: '',
        blue: 'primary',
        white: 'white',
        errorMessageCart: '',
        itemNumber: '193C',
        quantity: '25',
        savFromKey: 'Ub07GxNhS3yyoDfO',
        ccId: '766a5cef-6b51-4ab4-9f25-6446c4c8baeb',
        selected: '',
        imagepath: '',
        fav: true,
        menu: false,
        message: false,
        returnedSkuItem: null,
        hints: true,

        getRoundedUpFinalPrice,
        qtyPriceOptions: [],
        selectedQuantityPrice: 0.0,
        perSlides: 1,
        activeIndex: 0, // for variant carousel
        activePreviewIndex: 0, // for preview slider index
        productPartNameLabel: 'card and envelope',
        productPartNames: ['card', 'envelope'],
        productImageSliderImages: [],
        imgRef: null,

        productAllVariantsAllImages: {},
        slideHeight: '250px',
        computedThumbnailHeight: '',
        isThumbnailLoadedSuccessfully: false,
        defaultPlaceholderImage: 'https://cdn.crane.com/images/default_crane_image.webp',
        sliderPreviewLayout: {
            innerWidth: '100%', // in %
            frontImageWidth: '100%', // in %
            backImageWidth: '100%', // in %
            frontImageContainerWidth: '90%',
            backImageContainerWidth: '90%',
        },
        thumbSliderPreviewLayout: {
            innerWidth: '100%', // in %
            frontImageWidth: '90%', // in %
            backImageWidth: '90%', // in %
            frontImageContainerWidth: '85%',
            backImageContainerWidth: '85%',
        },
        partNameContent: null, // sheet, topFold, sideFold
        cardTopMargin: 9,
        productTotalPartsCount: 0,
        thumbnailImageLoaded: {},
        thumbnailImageError: {},
        previewImageLoaded: false,
        previewImageError: false,
        isAtLeftEnd: true,
        isAtRightEnd: false,
    }),
    computed: {
        productHasEnvelope: function () {
            let templatePreviewConfiguration = this.templateList[0]?.preview

            if (templatePreviewConfiguration?.parts) {
                let productHasEnvelopePart = templatePreviewConfiguration.parts.filter((part) =>
                    part.name?.toLowerCase().includes('envelope')
                )[0]
                return productHasEnvelopePart ? true : false
            }
            return false
        },
        savedForLaterList: function () {
            return this.$store.state.meSavedForLaterList.savedForLaterList
        },
        productDetails: function () {
            return this.$store.state.productOne.productDetails
        },
        templateList: function () {
            const data = this.$store.state.configurationTemplateList.list || []
            return [...data].sort((a) => (a.templateType === 'default' ? -1 : 1))
        },
        imageBasePathUrl() {
            return import.meta.env.VITE_APP_ECOMMERCE_MEDIA_URL
        },
        isHandwritingMode() {
            return typeof window !== 'undefined' && window[HANDWRITING_FLAG] === true
        },
        isCapacitorEmbed() {
            return getIsCapacitorEmbed()
        },
        sku: function () {
            return this.$route.meta.sku ? this.$route.meta.sku : this.$route.params.sku
        },
        itemId: function () {
            this.pageScrollUp()
            return this.$route.query.itemId
        },
        qty: function () {
            return this.$route.query.qty
        },

        /* qtyPriceOptions() {
            let vm = this;
            let qtyPriceArray = this.getCustomAttributeLable(
                this.productDetails.customAttribute,
                "qty_price"
            );
            if (qtyPriceArray) {
                let list = JSON.parse(
                    this.getCustomAttributeLable(
                        this.productDetails.customAttribute,
                        "qty_price"
                    )
                );
                if (this.qty) {
                    vm.selectedQty = this.qty.toString();
                } else {
                    vm.selectedQty = list[0].qty;
                }
                vm.validPersonalisedProduct = true;
                return list;
            } else {
                vm.validPersonalisedProduct = false;
            }
            return [];
        },*/
        numberOptions: function () {
            let vm = this
            if (this.productDetails.customAttribute) {
                let minSalesQty = this.getCustomAttributeLable(
                    this.productDetails.customAttribute,
                    'ba_min_sales_qty'
                )
                let qtyIncrements = this.getCustomAttributeLable(
                    this.productDetails.customAttribute,
                    'ba_qty_increments'
                )
                minSalesQty = Number(minSalesQty) ? Number(minSalesQty) : 1
                qtyIncrements = Number(qtyIncrements) ? Number(qtyIncrements) : 1

                let nums = []
                nums[0] = minSalesQty
                if (this.qty) {
                    vm.selectedQty = Number(this.qty)
                } else {
                    vm.selectedQty = minSalesQty
                }
                for (let i = 1; i <= 98; i++) {
                    minSalesQty = minSalesQty + qtyIncrements
                    nums[i] = minSalesQty
                }
                if (nums.length > 0) return nums
                else return ''
            } else {
                return ''
            }
        },
        userAuth: function () {
            return this.$store.state.auth.userAuth
        },
        guestQuoteId: function () {
            return this.$store.state.guestInfo.guestQuoteId
        },
        cartProductInProgress: function () {
            if (this.userAuth) {
                return this.$store.state.userCartProduct.inProgress
            } else {
                return this.$store.state.cartProduct.inProgress
            }
        },
        fetchErrorMessage: function () {
            return this.$store.state.productOne.errorMessage
        },
        productLdJson: function () {
            try {
                let product = null
                let productsList = window.craneCatalog.products
                Object.keys(productsList).forEach((key) => {
                    if (productsList[key].sku === this.$route.meta.sku) {
                        product = productsList[key]
                    }
                })
                console.log('product details', product)
                if (product) {
                    let data = {
                        '@context': 'https://schema.org',
                        '@type': 'Product',
                        description: product.d ? product.d : product.n,
                        name: product.n,
                        sku: product.sku,
                        image: this.imageBasePathUrl + product.i,
                        brand: {
                            '@type': 'Brand',
                            name: 'Crane',
                        },
                        offers: {
                            '@type': 'Offer',
                            url: baseUrl + '/' + product.uk,
                            availability: 'https://schema.org/InStock',
                            priceCurrency: 'USD',
                        },
                    }

                    if (product.sp) {
                        data.offers.price = Number(product.sp).toFixed(2)
                        return JSON.stringify(data)
                    } else if (product.qp) {
                        data.offers.price = Number(product.qp).toFixed(2)
                        return JSON.stringify(data)
                    } else if (product.lp) {
                        data.offers.price = Number(product.lp).toFixed(2)
                        return JSON.stringify(data)
                    } else if (product.p) {
                        data.offers.price = Number(product.p).toFixed(2)
                        return JSON.stringify(data)
                    }
                }
            } catch (error) {
                this.snackbar = {
                    message: error.message,
                    color: 'error',
                    show: true,
                    timeout: 3000,
                }
            }
            return null
        },
        ...mapFieldsAuth({
            oneLogin: 'one',
            emailLogin: 'one.email',
            passwordLogin: 'one.password',
            errorMessage: 'errorMessage',
            inProgress: 'inProgress',
            signInMessage: 'signInMessage',
        }),
        ...registerInfo([
            'one',
            'one.firstname',
            'one.lastname',
            'one.newsletter',
            'one.email',
            'one.password',
            'signUpMessage',
        ]),
        rewardsPoints: function () {
            return this.$store.state.productOne.rewardsPoints
        },

        breakpointName() {
            return this.$vuetify.display.name
        },
        breakPointForImage() {
            let sizes = {
                xs: 'lg',
                sm: 'md',
                md: 'md',
                lg: 'lg',
                xl: 'lg',
            }
            return sizes[this.breakpointName]
        },
        getCurrentPaperInformation: function () {
            if (this.templateList?.length) {
                this.productPartNames = []
                let currentTemplate = this.templateList[this.activeIndex]
                let productPapers = []
                if (currentTemplate && currentTemplate.baseStructure) {
                    // considered only 2 part
                    for (let p = 0; p < 2; p++) {
                        if (currentTemplate.baseStructure[p]) {
                            let currentpart = currentTemplate.baseStructure[p]
                            // create part names. if append & to first part
                            this.productPartNames.push(currentpart.name)

                            // consider only first part paper values for variation name
                            if (p === 0) {
                                for (let e = 0; e < currentpart.elements?.length; e++) {
                                    if (currentpart.elements[e].type === 'paper') {
                                        productPapers.push(currentpart.elements[e].value)
                                        break
                                    }
                                }
                            }
                        }
                    }
                    let paperLabel = `${productPapers[0]?.color} - ${productPapers[0]?.name} - ${productPapers[0]?.weight}`
                    this.productPartNameLabel = this.getProductPartNames(
                        this.productPartNames,
                        true
                    )
                    return paperLabel
                }
            }

            return ''
        },
    },
    watch: {
        productDetails: {
            immediate: true,
            handler() {
                this.imagepath =
                    this.productDetails.mediaGalleryEntries &&
                    this.productDetails.mediaGalleryEntries.length
                        ? this.productDetails.mediaGalleryEntries[0].file
                        : ''

                if (this.productDetails && this.productDetails.id) {
                    this.productReward(this.qty)
                }
            },
        },
        sku: {
            immediate: true,
            async handler() {
                if (this.sku) {
                    this.selectedQty = ''
                    await this.$store.dispatch('configurationTemplateList/fetchList', {
                        sku: this.sku,
                    })
                }
            },
        },
        templateList: {
            immediate: true,
            async handler() {
                if (this.templateList?.length) {
                    this.loadSliderPreviewLayoutConfiguration()
                    this.getQuantityPriceForSelectedVariant(0)

                    // create url based on part/product config like [templateId]:[url1, url2]
                    this.createImagesForSlider()
                    // load all images in background for cache purpose
                    this.preloadImagesForVariants(this.productAllVariantsAllImages)
                    this.getProductImagesForPreviewSlider(0)

                    // check variant thumbnail carsoule arrows
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.checkVariantDivScrollEdges()
                        }, 50)
                    })
                }
            },
        },
        savedForLaterList() {
            this.heartButtonActive()
        },
    },

    methods: {
        getLowestBasePrice(item) {
            if (!item || !item.basePrices) return null
            const prices = Object.values(item.basePrices)
                .map(Number)
                .filter((p) => !isNaN(p))

            return Math.min(...prices)
        },
        getProductPartNames(arr, pluralize = false) {
            if (!arr || arr.length === 0) return ''

            const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1)

            // When pluralizing, add 's' to each word
            const processed = arr.map((item) => (pluralize ? item + 's' : item))

            // Join with appropriate conjunction
            const conjunction = ' & '
            const joined =
                processed.length === 1
                    ? processed[0]
                    : processed.length === 2
                      ? processed.join(conjunction)
                      : `${processed.slice(0, -1).join(', ')}${conjunction}${processed.at(-1)}`

            // Adjust casing
            return pluralize ? capitalize(joined) : joined.toLowerCase()
        },
        getMagentoQtyPriceOptions() {
            let vm = this
            if (
                this.productDetails?.customAttribute &&
                this.productDetails.customAttribute.length
            ) {
                let qtyPriceArray = this.getCustomAttributeValue(
                    this.productDetails.customAttribute,
                    'qty_price'
                )

                if (qtyPriceArray) {
                    let list = JSON.parse(
                        this.getCustomAttributeValue(
                            this.productDetails.customAttribute,
                            'qty_price'
                        )
                    )
                    if (this.qty) {
                        vm.selectedQty = this.qty.toString()
                    } else {
                        vm.selectedQty = list[0].qty
                        vm.selectedQuantityPrice = this.getLowestBasePrice(list[0])
                    }
                    vm.validPersonalisedProduct = true
                    return list
                } else {
                    vm.validPersonalisedProduct = false
                }
                return []
            } else {
                return []
            }
        },
        isThumbnailImageLoaded(id) {
            return !!this.thumbnailImageLoaded[id]
        },
        isThumbnailImageError(id) {
            return !!this.thumbnailImageError[id]
        },
        errorLoadingThumbnailImage(templateId) {
            this.thumbnailImageLoaded[templateId] = true
            this.thumbnailImageError = false
            // send error to datadog error handler
            errorHandler.send(new Error('Thumbnail image failed to load'), {
                source: 'custom',
                templateId,
                component: 'ExpressPDPComponent',
                sku: this.sku,
                page: window.location.pathname,
            })
        },
        detectThumbnailHeight(event, imageId) {
            if (this.$refs.thumbImgRef && this.$refs.thumbImgRef[0]) {
                const img = event.target
                // fraction of seconds we get img.clientHeight as image original height like 500, 800. To get rid of that, we have to set it 60
                setTimeout(() => {
                    this.computedThumbnailHeight = img.clientHeight > 200 ? 60 : img.clientHeight
                }, 0)
                this.thumbnailImageLoaded[imageId] = true
                this.thumbnailImageError = false
            }
        },
        onImageLoad(event) {
            if (this.$refs.imgRef && this.$refs.imgRef[0] && this.$refs.innerContainerParent) {
                const innerContainerParentHeight = this.$refs.innerContainerParent[0]?.clientHeight

                if (!this.partNameContent || ['topFold'].includes(this.partNameContent)) {
                    this.cardTopMargin = 9
                }

                const marginInPx = innerContainerParentHeight * (this.cardTopMargin / 100)

                if (event && event.target.height) {
                    //  pt-5, pb-5 = 40px + marginInPx(margin top this.cardTopMargin %)
                    this.slideHeight = Number(event.target.height + marginInPx + 40) + 'px'

                    this.isThumbnailLoadedSuccessfully = true
                } else {
                    //  pt-5, pb-5 = 40px + marginInPx
                    this.slideHeight = Number(this.$refs.imgRef[0].height + marginInPx + 40) + 'px'
                }
                this.previewImageLoaded = true
                this.previewImageError = false
            }
        },
        isPreviewImageLoaded() {
            return !!this.previewImageLoaded
        },
        isPreviewImageError() {
            return !!this.previewImageError
        },
        // function to load default product images if variants = 1
        // loaded based on image height
        onProductDefaultImageLoad(event) {
            // Only set height once (first loaded image)
            if (this.slideHeight === '250px') {
                const img = event.target
                const containerWidth = img.clientWidth

                if (containerWidth > 0) {
                    const aspectRatio = img.naturalHeight / img.naturalWidth
                    this.slideHeight = `${containerWidth * aspectRatio}px`
                }
            }
        },
        onResize() {
            // if product default imgs are shown in preview slider
            if (this.templateList?.length === 1) {
                const imgEl = this.$refs.defaultImgRef
                if (imgEl && imgEl[0]?.naturalWidth > 0) {
                    const containerWidth = imgEl[0].clientWidth
                    const aspectRatio = imgEl[0].naturalHeight / imgEl[0].naturalWidth
                    this.slideHeight = `${containerWidth * aspectRatio}px`
                }
            } else {
                // if there are variants shown in preview slider
                this.onImageLoad()

                // check scroll for variant slider
                setTimeout(() => {
                    this.checkVariantDivScrollEdges()
                }, 50)
            }
        },
        onImageErrorDefault(templateId) {
            // send error to datadog error handler
            errorHandler.send(new Error('Thumbnail image failed to load'), {
                source: 'custom',
                component: 'ExpressPDPComponent',
                sku: this.sku,
                templateId: templateId ? templateId : '',
                page: window.location.pathname,
            })
        },
        onImageError(event, templateId) {
            // send error to datadog error handler
            errorHandler.send(new Error('Thumbnail image failed to load'), {
                source: 'custom',
                component: 'ExpressPDPComponent',
                sku: this.sku,
                templateId: templateId ? templateId : '',
                page: window.location.pathname,
            })
            const fallback = 'https://cdn.crane.com/images/default_crane_image.webp'
            event.target.src = fallback
        },
        loadSliderPreviewLayoutConfiguration() {
            // basically all related configuration is same for all templates
            this.partNameContent = null
            if (this.templateList?.length > 1) {
                let templatePreviewConfiguration = this.templateList[0].preview

                this.productTotalPartsCount = templatePreviewConfiguration.parts?.length

                let productHasSheet = templatePreviewConfiguration.parts.filter((part) =>
                    part.name?.toLowerCase().includes('sheet')
                )[0]

                if (productHasSheet) this.partNameContent = 'sheet'

                // product does not have "sheet" part
                if (!this.partNameContent && templatePreviewConfiguration?.parts?.length) {
                    // 4 is "top fold"
                    let productHasTopFoldPart = templatePreviewConfiguration.parts.filter(
                        (part) => part.orientationId === 4
                    )[0]
                    if (productHasTopFoldPart) this.partNameContent = 'topFold'
                    // 3 is "side fold"
                    let productHasSideFoldPart = templatePreviewConfiguration.parts.filter(
                        (part) => part.orientationId === 3
                    )[0]
                    if (productHasSideFoldPart) this.partNameContent = 'sideFold'

                    // on lowest priority check for vertical card
                    if (!this.partNameContent) {
                        // vertical cards
                        // check aspect ratio of front part
                        let productHasVerticalPart = templatePreviewConfiguration.parts.filter(
                            (part) => part.svgWidthPx / part.svgHeightPx < 1
                        )[0]
                        if (productHasVerticalPart) this.partNameContent = 'verticalCard'
                    }
                }

                // default to 100% for "topFold",sheet,verticalCard
                this.sliderPreviewLayout = {
                    innerWidth: '100%',
                    frontImageWidth: '100%',
                    frontImageContainerWidth: '90%',
                    backImageContainerWidth: '90%',
                    backImageWidth: '100%',
                }
                this.thumbSliderPreviewLayout = {
                    innerWidth: '100%', // in %
                    frontImageWidth: '90%', // in %
                    backImageWidth: '90%', // in %
                    frontImageContainerWidth: '90%',
                    backImageContainerWidth: '90%',
                }

                // if product has only one Part
                if (this.productTotalPartsCount === 1) {
                    this.sliderPreviewLayout = {
                        innerWidth: '100%',
                        frontImageWidth: '100%',
                        frontImageContainerWidth: '100%',
                        backImageContainerWidth: '0%',
                        backImageWidth: '0%',
                    }
                    this.thumbSliderPreviewLayout = {
                        innerWidth: '100%', // in %
                        frontImageWidth: '100%', // in %
                        frontImageContainerWidth: '100%',
                        backImageWidth: '0%', // in %
                        backImageContainerWidth: '0%',
                    }
                }
                // based on part conditions for images
                if (['sideFold', 'sheet', 'verticalCard'].includes(this.partNameContent)) {
                    this.sliderPreviewLayout.innerWidth = '83%'
                    this.thumbSliderPreviewLayout.innerWidth = '83%'
                }
            }
        },
        /*
         * Updates the quantity price options and selected quantity price for the selected product variant.
         * @param {number} index - The index of the selected template in `templateList`.
         */
        getQuantityPriceForSelectedVariant(index) {
            if (this.templateList?.length) {
                this.qtyPriceOptions = this.templateList?.[index]?.priceVariants

                if (!this.selectedQty && this.qtyPriceOptions?.length) {
                    this.selectedQty = this.qtyPriceOptions[0]?.qty
                    this.selectedQuantityPrice = this.getLowestBasePrice(this.qtyPriceOptions[0])
                }
            }
            if (!this.qtyPriceOptions?.length) {
                this.qtyPriceOptions = this.getMagentoQtyPriceOptions()
            }
            // to override selected quantity price on template change
            if (this.qtyPriceOptions?.length) {
                let priceOption = this.qtyPriceOptions.filter((q) => q.qty == this.selectedQty)[0]
                this.selectedQuantityPrice = this.getLowestBasePrice(priceOption)
            }
        },
        // create a thumbnail slider image urls
        createImagesForSlider() {
            this.productAllVariantsAllImages = {}
            if (this.templateList?.length > 1) {
                for (let i = 0; i < this.templateList?.length; i++) {
                    let id = this.templateList[i].id
                    let templatePreviewConfiguration = this.templateList[i].preview
                    // front part is always first part
                    let frontPart = templatePreviewConfiguration?.parts[0] || []
                    let backImageUrl = null
                    let frontImageUrl = null
                    if (this.templateList[i]?.imageIds?.length) {
                        // default images
                        backImageUrl = this.templateList[i]?.imageIds[1]
                            ? useCloudflareImgUrl(
                                  this.templateList[i]?.imageIds[1],
                                  'pdpThumbnail',
                                  'lg'
                              )
                            : null
                        frontImageUrl = this.templateList[i]?.imageIds[0]
                            ? useCloudflareImgUrl(
                                  this.templateList[i]?.imageIds[0],
                                  'pdpThumbnail',
                                  'lg'
                              )
                            : null
                        // change images based on product part
                        if (this.partNameContent === 'topFold') {
                            // trim from top side to center
                            frontImageUrl = this.templateList[i]?.imageIds[0]
                                ? `${cloudflareImageDeliveryUrl}/${
                                      this.templateList[i]?.imageIds[0]
                                  }/trim.top=${Math.ceil(frontPart.svgHeightPx / 2)}`
                                : null
                        } else if (this.partNameContent === 'sideFold') {
                            // trim from left side to center
                            frontImageUrl = this.templateList[i]?.imageIds[0]
                                ? `${cloudflareImageDeliveryUrl}/${
                                      this.templateList[i]?.imageIds[0]
                                  }/trim.left=${Math.ceil(frontPart.svgWidthPx / 2)}`
                                : null
                            backImageUrl = this.templateList[i]?.imageIds[1]
                                ? `${cloudflareImageDeliveryUrl}/${this.templateList[i]?.imageIds[1]}/rotate=90`
                                : null
                        } else if (this.partNameContent === 'verticalCard') {
                            // load this image to scale proportionally with envelope
                            frontImageUrl = this.templateList[i]?.imageIds[0]
                                ? `${cloudflareImageDeliveryUrl}/${this.templateList[i]?.imageIds[0]}/trim.top=0`
                                : null
                            // only rotate envelope to 90 degree
                            backImageUrl = this.templateList[i]?.imageIds[1]
                                ? `${cloudflareImageDeliveryUrl}/${this.templateList[i]?.imageIds[1]}/rotate=90`
                                : null
                        }
                    }
                    if (frontImageUrl && backImageUrl) {
                        this.productAllVariantsAllImages[id] = [frontImageUrl, backImageUrl]
                    }
                    if (frontImageUrl && !backImageUrl) {
                        this.productAllVariantsAllImages[id] = [frontImageUrl]
                    }
                }
            }
        },
        // preview slider = top one bigger slider
        getProductImagesForPreviewSlider(index) {
            this.productImageSliderImages = []
            this.previewImageLoaded = false
            this.previewImageError = false
            // if only paper variants then do show all media gallery
            if (this.templateList?.length > 1) {
                let templateId = this.templateList[index].id

                this.productImageSliderImages.push(this.productAllVariantsAllImages[templateId])
            }
            for (let img = 0; img < this.productDetails.mediaGalleryEntries?.length; img++) {
                // if only paper variants then do show all media gallery
                if (this.templateList?.length > 1 && img === 0) continue

                let currentFile = this.productDetails.mediaGalleryEntries[img].file
                currentFile =
                    mediaImageUrl + '/' + this.fetchProductImageName(currentFile) + '_768.webp'
                this.productImageSliderImages.push(currentFile)
            }
        },
        setActivePreview(index) {
            this.activeIndex = index
            this.getQuantityPriceForSelectedVariant(index)
            this.getProductImagesForPreviewSlider(index)
            if (this.$refs.mainSlider) {
                this.$refs.mainSlider.goToSlide(0) // slider always start from 0th
            }
            this.scrollIntoView(index)
        },
        onSlideChange({ currentSlide }) {
            this.activePreviewIndex = currentSlide?.index || 0
        },
        goToPreviewSlide(index) {
            this.$refs.mainSlider.goToSlide(index)
            this.activePreviewIndex = index
        },
        productReward(qty) {
            try {
                let price = this.productDetails.price
                let quantity = qty ? qty : 1
                let isPersonalize = this.getCustomAttributeValue(
                    this.productDetails.customAttribute,
                    'personalized'
                )
                if (isPersonalize == 'Yes') {
                    if (this.qtyPriceOptions?.length > 0) {
                        if (!qty) {
                            quantity = this.qtyPriceOptions[0].qty
                            price = Number(this.qtyPriceOptions[0].price) / Number(quantity)
                            this.selectedQuantityPrice = this.getLowestBasePrice(
                                this.qtyPriceOptions[0]
                            )
                        } else {
                            let priceOption = this.qtyPriceOptions.filter(
                                (q) => q.qty == quantity
                            )[0]
                            this.selectedQuantityPrice = this.getLowestBasePrice(priceOption)
                            price = Number(priceOption.price) / Number(quantity)
                        }
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },

        replacePriceString(str) {
            let val = str.replace('price:"', '')
            val = val.replace('"}', '')
            return val
        },
        fetchProductImageName(imageFullName) {
            if (imageFullName) {
                let fileExtention = imageFullName.split('/')
                let filename = fileExtention[fileExtention.length - 1].split('.')[0]
                return filename
            } else {
                return ''
            }
        },
        heartButtonActive() {
            if (this.savedForLaterList && this.savedForLaterList.wishlistItems.length) {
                for (let i = 0; i < this.savedForLaterList.wishlistItems.length; i++) {
                    if (
                        this.productDetails.sku ===
                        this.savedForLaterList.wishlistItems[i].product.sku
                    ) {
                        this.isFillHeart = true
                        this.isOutlineHeart = false
                        this.myBtnColor = 'red'
                    }
                }
            }
        },

        async addToSaveToLater(sku) {
            if (this.userAuth) {
                await this.$store
                    .dispatch('savedForLaterOne/addToSavedForLater', {
                        sku: sku,
                    })
                    .then(() => {
                        this.$store.dispatch('meSavedForLaterList/fetchSavedForLaterList')

                        this.snackbar = {
                            message: 'Product added in wishlist successfully',
                            color: 'success',
                            show: true,
                            timeout: 3000,
                        }
                    })
                    .catch((error) => {
                        this.snackbar = {
                            message: error.message,
                            color: 'error',
                            show: true,
                            timeout: 3000,
                        }
                    })
            } else {
                this.signInForm = true
            }
        },
        async signInPop() {
            this.signInForm = true
        },
        async signIn(sku) {
            const { valid } = await this.$refs.loginForm.validate()
            if (valid) {
                this.$store.dispatch('auth/changeRedirectFlag', false)
                this.$store.dispatch('auth/login').then((status) => {
                    if (status) {
                        this.$store.dispatch('auth/changeRedirectFlag', true)
                        this.$store.dispatch('accountOne/basicInfo')
                        this.$store.dispatch('userCartProduct/cartProductList')

                        this.signInForm = false
                    }
                })
            }
        },
        async signUp(sku) {
            const { valid } = await this.$refs.signUpForm.validate()
            if (valid) {
                try {
                    this.$store.dispatch('auth/changeRedirectFlag', false)
                    await this.$store.dispatch('registration/signUp').then((status) => {
                        if (status) {
                            this.$store.dispatch('auth/changeRedirectFlag', false)
                            this.$store.dispatch('accountOne/basicInfo')
                            this.$store.dispatch('userCartProduct/cartProductList')

                            this.signUpForm = false
                            this.signInForm = false
                        }
                    })
                } catch (err) {
                    console.log(err)
                }
            }
        },
        closeSignInForm() {
            this.signInForm = false
            this.$store.dispatch('auth/changeRedirectFlag', true)
        },
        closeSignUpForm() {
            this.signUpForm = false
            this.$store.dispatch('auth/changeRedirectFlag', true)
        },
        openSignInDialog() {
            this.signInForm = true
            this.signUpForm = false
        },
        openSignUpDialog() {
            this.signInForm = false
            this.signUpForm = true
        },
        goToForgetPassword() {
            window.open(`/gate/forgot-password`, '_self')
        },
        setAltImg() {
            event.target.src = this.productDefaultImage
        },
        getCustomAttributeValue(customAttributes, attributeCode) {
            return customAttributeValue(customAttributes, attributeCode)
        },
        addToCart(sku, productDetails) {
            try {
                let vm = this
                let qtyNew = this.selectedQty
                if (this.selectedQty) {
                    this.errorMessageCart = ''
                    if (this.userAuth) {
                        this.$store
                            .dispatch('userCartProduct/addToCart', {
                                sku: sku,
                                qty: this.selectedQty,
                                ccid: null,
                                price: null,
                                personalizeDetails: null,
                            })
                            .then((res) => {
                                googleAanalytics(
                                    vm,
                                    res,
                                    productDetails,
                                    qtyNew,
                                    'add_to_cart',
                                    'Ecommerce',
                                    vm.categoryListIdWise,
                                    googleAanalytics,
                                    sku
                                )
                                if (this.categoryId) {
                                    setCategoryNameInLocal(this.categoryId, res)
                                }

                                this.$store.dispatch('userCartProduct/cartProductList')

                                this.$store.dispatch('userCartProduct/cartDrawer', true)
                                this.snackbar = {
                                    message: 'Product Added Successfully',
                                    color: 'success',
                                    show: true,
                                    timeout: 2000,
                                }
                            })
                            .catch((error) => {
                                this.snackbar = {
                                    message: error.message,
                                    color: 'error',
                                    show: true,
                                    timeout: 2000,
                                }
                            })
                    } else {
                        this.$store
                            .dispatch('cartProduct/addToCart', {
                                sku: sku,
                                qty: this.selectedQty,
                                ccid: null,
                                price: null,
                                personalizeDetails: null,
                            })
                            .then((res) => {
                                googleAanalytics(
                                    vm,
                                    res,
                                    productDetails,
                                    qtyNew,
                                    'add_to_cart',
                                    'Ecommerce',
                                    vm.categoryListIdWise,
                                    sku
                                )
                                if (this.categoryId) {
                                    setCategoryNameInLocal(this.categoryId, res)
                                }
                                this.snackbar = {
                                    message: 'Product Added Successfully',
                                    color: 'success',
                                    show: true,
                                    timeout: 2000,
                                }
                            })
                            .catch((error) => {
                                this.snackbar = {
                                    message: error.message,
                                    color: 'error',
                                    show: true,
                                    timeout: 2000,
                                }
                            })
                    }
                } else {
                    this.errorMessageCart = 'Please Select Quantity'
                }
            } catch (error) {
                console.log('error', error)
            }
        },
        updateToCart(productName, sku) {
            try {
                if (this.selectedQty) {
                    this.errorMessageCart = ''
                    if (this.userAuth) {
                        this.$store
                            .dispatch('userCartProduct/updateToCart', {
                                sku: sku,
                                qty: this.selectedQty,
                                itemId: this.itemId,
                                ccid: null,
                                price: null,
                                personalizeDetails: null,
                            })
                            .then((res) => {
                                this.snackbar = {
                                    message: 'Product Updated Successfully',
                                    color: 'success',
                                    show: true,
                                    timeout: 3000,
                                }
                                this.$router.replace({
                                    query: {
                                        qty: this.selectedQty,
                                        itemId: res.item_id,
                                    },
                                })
                            })
                            .catch((error) => {
                                this.snackbar = {
                                    message: error.message,
                                    color: 'error',
                                    show: true,
                                    timeout: 3000,
                                }
                            })
                    } else {
                        this.$store
                            .dispatch('cartProduct/updateToCart', {
                                sku: sku,
                                qty: this.selectedQty,

                                itemId: this.itemId,
                                ccid: null,
                                price: null,
                                personalizeDetails: null,
                            })
                            .then((res) => {
                                this.snackbar = {
                                    message: 'Product Updated Successfully',
                                    color: 'success',
                                    show: true,
                                    timeout: 3000,
                                }

                                this.$router.replace({
                                    query: {
                                        qty: this.selectedQty,
                                        itemId: res.item_id,
                                    },
                                })
                            })
                            .catch((error) => {
                                this.snackbar = {
                                    message: error.message,
                                    color: 'error',
                                    show: true,
                                    timeout: 3000,
                                }
                            })
                    }
                } else {
                    this.errorMessageCart = 'Please Select Quantity'
                }
            } catch (error) {
                console.log('error', error)
            }
        },

        getCustomAttributeLable(customAttributes, attributeCode) {
            return getLable(customAttributes, attributeCode)
        },

        setValue(color) {
            return (this.selected = color) && (this.errorMessageCart = '')
        },
        submit() {
            if (this.selected !== '') {
                return (this.selected = '') && (this.errorMessageCart = '')
            } else {
                this.errorMessageCart = 'Please Select Color'
            }
        },
        goToPersonalize(productDetails) {
            try {
                googleAanalyticsEvent('personalize_builder', 'ecommerce', productDetails)
                let currentindex = this.activeIndex
                let currentTemplate = this.templateList[currentindex]
                let currentTemplateId = currentTemplate.id
                // When embedded in Capacitor app iframe, tell parent to navigate to designer (Capacitor page), not open in iframe.
                // Use flag set at load by capacitorIframeBack plugin so we still detect embed after internal nav (URL often loses capacitor=true).
                const inCapacitorIframe =
                    getIsCapacitorEmbed() && typeof window !== 'undefined' && window !== window.top
                if (inCapacitorIframe) {
                    const storefrontPath =
                        typeof window.location.pathname === 'string'
                            ? window.location.pathname.replace(/^\//, '') +
                              (window.location.search || '')
                            : ''
                    const payload = {
                        type: 'EXPRESS_CREATE_HANDWRITING_STATIONERY',
                        sku: this.sku,
                        templateConfigId: currentTemplateId,
                        storefrontPath: storefrontPath || undefined,
                    }
                    if (!this.isHandwritingMode) {
                        payload.quantity = this.selectedQty
                    }
                    window.parent.postMessage(payload, '*')
                    return
                }

                // Handwriting mode → designer/start/handwriting (customize-mode); purchase → designer/start/purchase
                const designerUrl = this.isHandwritingMode
                    ? `${designerPageUrl}/designer/start/handwriting/${this.sku}/${currentTemplateId}`
                    : `${designerPageUrl}/designer/start/${this.sku}/${currentTemplateId}?quantity=${this.selectedQty}`
                window.open(designerUrl, '_self')
            } catch (error) {
                console.log('error', error)
            }
        },
        setSelected(part, index) {
            this.imagepath = part
            this.selected = index
        },
        pageScrollUp() {
            const data = this.$refs.expressPdpDivOne
            if (data) {
                this.$smoothScroll({
                    scrollTo: data.scrollTop,
                    duration: 300,
                    easingFunction: 'easeInOutCubic',
                    updateHistory: false,
                })
            }
        },

        selectPrev() {
            const container = this.$refs.scrollContainer
            if (!container) return

            container.scrollLeft -= 96 //80px = thumbnail width, 16px margin
            // if (this.activeIndex > 0) {
            //     this.activeIndex = this.activeIndex - 1;
            //     this.setActivePreview(this.activeIndex);
            // }
            this.$nextTick(() => this.checkVariantDivScrollEdges())
        },

        selectNext() {
            const container = this.$refs.scrollContainer
            if (!container) return

            container.scrollLeft += 96 //80px = thumbnail width, 16px margin
            // if (this.activeIndex < this.templateList.length - 1) {
            //     this.activeIndex = this.activeIndex + 1;
            //     this.setActivePreview(this.activeIndex);
            // }
            this.$nextTick(() => this.checkVariantDivScrollEdges())
        },
        checkVariantDivScrollEdges() {
            const container = this.$refs.scrollContainer
            if (!container) return

            const maxScroll = container.scrollWidth - container.clientWidth
            // CASE 1: if variants are minimum that does not scroll div
            if (maxScroll <= 0) {
                this.isAtLeftEnd = true
                this.isAtRightEnd = true
                return
            }

            // CASE 2: Normal scroll logic
            this.isAtLeftEnd = container.scrollLeft <= 0
            this.isAtRightEnd = container.scrollLeft >= maxScroll - 2 // tiny buffer
        },
        scrollIntoView(index) {
            this.$nextTick(() => {
                const el = document.getElementById(`${index}_variantion_div`)
                const container = this.$refs.scrollContainer
                if (el && container) {
                    // scroll horizontally so the element is centered in the container
                    container.scrollLeft =
                        el.offsetLeft -
                        container.offsetLeft -
                        container.clientWidth / 2 +
                        el.clientWidth / 2
                }
            })
        },
        preloadImagesForVariants(productAllVariantsAllImages) {
            if (productAllVariantsAllImages) {
                let templateIds = Object.keys(productAllVariantsAllImages)
                for (let i = 0; i < templateIds.length; i++) {
                    let currentId = templateIds[i]
                    if (currentId) {
                        let urls = productAllVariantsAllImages[currentId]
                        urls.forEach((url) => {
                            const img = new Image()
                            img.src = url
                        })
                    }
                }
            }
        },
    },
    mounted() {
        this.pageScrollUp()
        this.$watch(
            () => this.productDetails?.mediaGalleryEntries?.length,
            () => {
                this.getQuantityPriceForSelectedVariant(0)
                this.getProductImagesForPreviewSlider(0)
            },
            { immediate: true }
        )

        // Fix initial load issue: calculate slide height after DOM is ready
        this.$nextTick(() => {
            // Wait a bit for images to potentially load and layout to calculate
            setTimeout(() => {
                if (this.templateList?.length > 1) {
                    // Variants case
                    this.onImageLoad()
                }
            }, 100)
        })
    },
    async created() {
        try {
            if (this.itemId) {
                this.updateProgress = true
                setTimeout(() => {
                    this.updateProgress = false
                }, 3000)
            }
        } catch (err) {
            this.snackbar = {
                message: err.message,
                color: 'error',
                show: true,
                timeout: 3000,
            }
        }
    },
}
</script>
<style src="./ExpressPDPComponent.scss" lang="scss" />
